import './polyfills/querySelectorFix';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { StrictMode, useLayoutEffect } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
//import Test from './testTable.jsx'
import '././styles/shared.scrollbar.css';
import '././styles/Shared.css';
import '././styles/shared.themes.css';
import 'blick.react.themes/themes.less';
import 'rsuite/dist/rsuite.min.css';
//import './styles//rsuite.custom.css';
import 'blick.react.themes/rsuite.custom.less'
//import './styles//rsuite.theme.css';
import { axiosWithAuth, ErrorBoundary, initAuthConfig, initAutoRefresh, useAuth } from 'blick.react.utils';
import { CustomProvider } from 'rsuite';
import { ruRU } from 'rsuite/esm/locales';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './query';
import { router } from './router';
import { RouterProvider } from '@tanstack/react-router';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import { ToastContainer } from 'react-toastify';
import context from './components/Administration/context/shared';
import { observer } from 'mobx-react-lite';


initAuthConfig({
    authUrl: 'api/Account/auth',
    signInUrl: 'api/Account/sign-in',
    signOutUrl: 'api/Account/sign-out',
    refreshUrl: 'api/Account/refresh'
})

axiosWithAuth.defaults.baseURL = undefined;

initAutoRefresh({ checkIntervalMs: 5000, refreshThresholdMs: 30000 });

const App = observer(() => {
    const { theme} = context;

    useLayoutEffect(() => {
        const container = document.body;
        container.setAttribute("data-theme", theme);
    }, [theme])
    return (
        <QueryClientProvider client={queryClient}>
            <RouterProviderWithContext />
            <ToastContainer position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                pauseOnHover
                theme={theme}
            />
        </QueryClientProvider>

    )
})

function RouterProviderWithContext() {
    const auth = useAuth(router)

    return <RouterProvider router={router} context={{ auth }} />
}

declare global {
    interface Window {
        readonly app: HTMLElement
    }
}
dayjs.locale('ru')
axiosWithAuth.defaults.baseURL = undefined;

createRoot(document.body).render(
    //<StrictMode>
    <ErrorBoundary>
        <CustomProvider locale={ruRU}>
            <App />
        </CustomProvider>
    </ErrorBoundary>
    //</StrictMode>
)
